(function () {
  'use strict';

  // ─── Global lightbox state ────────────────────────────────────────────────────

  var lightbox = null;
  var media = [];
  var currentIndex = 0;
  var galleryEl = null;
  var triggerEl = null;
  var scrollY = 0;
  var touchStartX = 0;
  var touchStartY = 0;

  // ─── Zoom state ───────────────────────────────────────────────────────────────

  var isZoomed = false;
  var ZOOM_SCALE = 2.5;
  var zoomTx = 0;
  var zoomTy = 0;
  var panActive = false;
  var panStartX = 0;
  var panStartY = 0;
  var panStartTx = 0;
  var panStartTy = 0;
  var hasPanned = false;

  // ─── DOM build ───────────────────────────────────────────────────────────────

  function build() {
    var el = document.createElement('div');
    el.id = 'product-lightbox';
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-modal', 'true');
    el.setAttribute('aria-label', 'Product image viewer');
    el.hidden = true;
    el.innerHTML =
      '<button class="lightbox__close" aria-label="Close lightbox">' +
        '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>' +
      '</button>' +
      '<div class="lightbox__header">' +
        '<span class="lightbox__counter" aria-live="polite" aria-atomic="true">1 / 1</span>' +
      '</div>' +
      '<div class="lightbox__stage">' +
        '<button class="lightbox__prev" aria-label="Previous image">' +
          '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg>' +
        '</button>' +
        '<div class="lightbox__viewport"></div>' +
        '<button class="lightbox__next" aria-label="Next image">' +
          '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>' +
        '</button>' +
      '</div>' +
      '<div class="lightbox__thumbs"></div>';

    document.body.appendChild(el);
    lightbox = el;
    bindEvents();
    bindZoomEvents();
  }

  // ─── Media collection ─────────────────────────────────────────────────────────

  function collectMedia(gallery) {
    var slides = gallery.querySelectorAll('.images .swiper-slide[data-lightbox-type]');
    var result = [];
    for (var i = 0; i < slides.length; i++) {
      var slide = slides[i];
      result.push({
        type: slide.dataset.lightboxType,
        src: slide.dataset.lightboxSrc || '',
        alt: slide.dataset.lightboxAlt || '',
        thumb: slide.dataset.lightboxThumb || slide.dataset.lightboxSrc || '',
        poster: slide.dataset.lightboxPoster || '',
        videoId: slide.dataset.lightboxVideoId || '',
        videoHost: slide.dataset.lightboxVideoHost || '',
      });
    }
    return result;
  }

  // ─── Open / close ─────────────────────────────────────────────────────────────

  function open(gallery, index, trigger) {
    if (!lightbox) build();

    galleryEl = gallery;
    media = collectMedia(gallery);
    if (!media.length) return;

    currentIndex = Math.max(0, Math.min(index, media.length - 1));
    // Use the explicitly passed element (e.g. the clicked slide) so focus returns
    // to the right place on close, even for mouse users where activeElement may not be set.
    triggerEl = trigger || document.activeElement;

    lockScroll();
    resetZoomState();

    lightbox.hidden = false;
    renderViewport(currentIndex);
    renderThumbs();
    updateCounter();
    updateNavButtons();

    var closeBtn = lightbox.querySelector('.lightbox__close');
    if (closeBtn) closeBtn.focus();
  }

  function close() {
    if (!lightbox || lightbox.hidden) return;

    clearViewport();
    resetZoomState();
    lightbox.hidden = true;
    unlockScroll();

    if (window.productGallerySwiper) {
      window.productGallerySwiper.slideTo(currentIndex, 0);
    }
    if (window.bundleGallerySwiper) {
      window.bundleGallerySwiper.slideTo(currentIndex, 0);
    }

    if (triggerEl && typeof triggerEl.focus === 'function') {
      triggerEl.focus();
    }
  }

  // ─── Navigation ───────────────────────────────────────────────────────────────

  function goTo(index) {
    var count = media.length;
    currentIndex = ((index % count) + count) % count;
    resetZoomState();
    clearViewport();
    renderViewport(currentIndex);
    updateCounter();
    updateNavButtons();
    updateThumbActive();
  }

  function prev() { goTo(currentIndex - 1); }
  function next() { goTo(currentIndex + 1); }

  // ─── Render viewport ──────────────────────────────────────────────────────────

  function clearViewport() {
    var vp = lightbox.querySelector('.lightbox__viewport');
    var video = vp.querySelector('video');
    if (video) { video.pause(); video.src = ''; }
    var iframe = vp.querySelector('iframe');
    if (iframe) { iframe.src = ''; }
    vp.innerHTML = '';
  }

  function renderViewport(index) {
    var item = media[index];
    var vp = lightbox.querySelector('.lightbox__viewport');
    if (!item) return;

    if (item.type === 'image') {
      var img = document.createElement('img');
      img.src = item.src;
      img.alt = item.alt;
      img.className = 'lightbox__image';
      vp.appendChild(img);
    } else if (item.type === 'video') {
      if (item.src && (item.src.indexOf('youtube') !== -1 || item.src.indexOf('youtu.be') !== -1)) {
        renderYouTube(vp, extractYouTubeId(item.src));
      } else if (item.src && item.src.indexOf('vimeo') !== -1) {
        renderVimeo(vp, extractVimeoId(item.src));
      } else {
        var video = document.createElement('video');
        video.src = item.src;
        video.controls = true;
        video.autoplay = true;
        video.setAttribute('playsinline', '');
        video.setAttribute('webkit-playsinline', '');
        if (item.poster) video.poster = item.poster;
        video.className = 'lightbox__video';
        vp.appendChild(video);
      }
    } else if (item.type === 'external_video') {
      if (item.videoHost === 'youtube') {
        renderYouTube(vp, item.videoId);
      } else if (item.videoHost === 'vimeo') {
        renderVimeo(vp, item.videoId);
      }
    }
  }

  function renderYouTube(container, videoId) {
    var iframe = document.createElement('iframe');
    iframe.src = 'https://www.youtube.com/embed/' + videoId + '?autoplay=1&enablejsapi=1';
    iframe.allow = 'autoplay; encrypted-media';
    iframe.allowFullscreen = true;
    iframe.className = 'lightbox__iframe';
    iframe.setAttribute('title', 'Video');
    container.appendChild(iframe);
  }

  function renderVimeo(container, videoId) {
    var iframe = document.createElement('iframe');
    iframe.src = 'https://player.vimeo.com/video/' + videoId + '?autoplay=1';
    iframe.allow = 'autoplay; encrypted-media';
    iframe.allowFullscreen = true;
    iframe.className = 'lightbox__iframe';
    iframe.setAttribute('title', 'Video');
    container.appendChild(iframe);
  }

  function extractYouTubeId(url) {
    var match = url.match(/(?:v=|youtu\.be\/)([^&?/]+)/);
    return match ? match[1] : '';
  }

  function extractVimeoId(url) {
    var match = url.match(/vimeo\.com\/(\d+)/);
    return match ? match[1] : '';
  }

  // ─── Thumbnails ───────────────────────────────────────────────────────────────

  function renderThumbs() {
    var container = lightbox.querySelector('.lightbox__thumbs');
    container.innerHTML = '';

    for (var i = 0; i < media.length; i++) {
      var item = media[i];
      var btn = document.createElement('button');
      btn.className = 'lightbox__thumb' + (i === currentIndex ? ' is-active' : '');
      btn.setAttribute('aria-label', 'View image ' + (i + 1));
      btn.dataset.index = i;

      var img = document.createElement('img');
      img.src = item.thumb || item.src;
      img.alt = item.alt || '';
      img.loading = 'lazy';
      img.width = 72;
      img.height = 72;

      if (item.type === 'video' || item.type === 'external_video') {
        var playOverlay = document.createElement('span');
        playOverlay.className = 'lightbox__thumb-play';
        playOverlay.setAttribute('aria-hidden', 'true');
        btn.appendChild(img);
        btn.appendChild(playOverlay);
      } else {
        btn.appendChild(img);
      }

      container.appendChild(btn);
    }

    setTimeout(function () { scrollThumbIntoView(currentIndex); }, 50);
  }

  function updateThumbActive() {
    var thumbs = lightbox.querySelectorAll('.lightbox__thumb');
    for (var i = 0; i < thumbs.length; i++) {
      thumbs[i].classList.toggle('is-active', i === currentIndex);
    }
    scrollThumbIntoView(currentIndex);
  }

  function scrollThumbIntoView(index) {
    var container = lightbox.querySelector('.lightbox__thumbs');
    var thumb = container.querySelectorAll('.lightbox__thumb')[index];
    if (thumb) thumb.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
  }

  // ─── Counter + nav buttons ────────────────────────────────────────────────────

  function updateCounter() {
    var counter = lightbox.querySelector('.lightbox__counter');
    if (counter) counter.textContent = (currentIndex + 1) + ' / ' + media.length;
  }

  function updateNavButtons() {
    var prevBtn = lightbox.querySelector('.lightbox__prev');
    var nextBtn = lightbox.querySelector('.lightbox__next');
    var single = media.length <= 1;
    if (prevBtn) prevBtn.hidden = single;
    if (nextBtn) nextBtn.hidden = single;
  }

  // ─── iOS scroll lock ──────────────────────────────────────────────────────────

  function lockScroll() {
    scrollY = window.scrollY || window.pageYOffset;
    document.body.style.position = 'fixed';
    document.body.style.top = '-' + scrollY + 'px';
    document.body.style.width = '100%';
    document.body.style.overflowY = 'scroll';
  }

  function unlockScroll() {
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    document.body.style.overflowY = '';
    window.scrollTo(0, scrollY);
  }

  // ─── Zoom / pan ───────────────────────────────────────────────────────────────

  function resetZoomState() {
    isZoomed = false;
    zoomTx = 0;
    zoomTy = 0;
    panActive = false;
    hasPanned = false;
  }

  function applyZoom(img) {
    img.style.transform = 'translate(' + zoomTx + 'px, ' + zoomTy + 'px) scale(' + ZOOM_SCALE + ')';
  }

  function zoomIn(img, clientX, clientY) {
    var rect = img.getBoundingClientRect();
    // Click position relative to image centre
    var cxRel = clientX - (rect.left + rect.width / 2);
    var cyRel = clientY - (rect.top + rect.height / 2);
    // Translate so the clicked point ends up at the viewport centre
    zoomTx = -cxRel * (ZOOM_SCALE - 1);
    zoomTy = -cyRel * (ZOOM_SCALE - 1);
    isZoomed = true;
    img.style.transition = 'transform 0.2s ease-out';
    img.style.cursor = 'grab';
    applyZoom(img);
    setTimeout(function () { if (img) img.style.transition = 'none'; }, 220);
  }

  function zoomOut(img) {
    isZoomed = false;
    zoomTx = 0;
    zoomTy = 0;
    img.style.transition = 'transform 0.2s ease-out';
    img.style.cursor = 'zoom-in';
    img.style.transform = '';
    setTimeout(function () { if (img) img.style.transition = ''; }, 220);
  }

  function bindZoomEvents() {
    var vp = lightbox.querySelector('.lightbox__viewport');

    // ── Click: zoom in / zoom out ───────────────────────────────────────────────
    vp.addEventListener('click', function (e) {
      var img = vp.querySelector('.lightbox__image');
      if (!img) return;

      if (!isZoomed) {
        zoomIn(img, e.clientX, e.clientY);
      } else if (!hasPanned) {
        zoomOut(img);
      }
      hasPanned = false;
    });

    // ── Pointer down: start pan (zoomed only) ────────────────────────────────────
    vp.addEventListener('pointerdown', function (e) {
      var img = vp.querySelector('.lightbox__image');
      if (!img || !isZoomed) return;
      panActive = true;
      hasPanned = false;
      panStartX = e.clientX;
      panStartY = e.clientY;
      panStartTx = zoomTx;
      panStartTy = zoomTy;
      img.style.cursor = 'grabbing';
      img.style.transition = 'none';
      try { vp.setPointerCapture(e.pointerId); } catch (err) {}
    });

    // ── Pointer move: pan ─────────────────────────────────────────────────────────
    vp.addEventListener('pointermove', function (e) {
      if (!panActive) return;
      var img = vp.querySelector('.lightbox__image');
      if (!img) return;
      var dx = e.clientX - panStartX;
      var dy = e.clientY - panStartY;
      if (Math.abs(dx) > 5 || Math.abs(dy) > 5) hasPanned = true;
      zoomTx = panStartTx + dx;
      zoomTy = panStartTy + dy;
      applyZoom(img);
    });

    // ── Pointer up / cancel ────────────────────────────────────────────────────────
    function endPan() {
      if (!panActive) return;
      panActive = false;
      var img = vp.querySelector('.lightbox__image');
      if (img && isZoomed) img.style.cursor = 'grab';
    }
    vp.addEventListener('pointerup', endPan);
    vp.addEventListener('pointercancel', endPan);
    vp.addEventListener('pointerleave', endPan);

    // ── Prevent page scroll during touch pan ────────────────────────────────────
    vp.addEventListener('touchmove', function (e) {
      if (isZoomed && panActive) e.preventDefault();
    }, { passive: false });
  }

  // ─── Main event binding ───────────────────────────────────────────────────────

  function bindEvents() {
    lightbox.querySelector('.lightbox__close').addEventListener('click', close);

    // Backdrop click
    lightbox.addEventListener('click', function (e) {
      if (e.target === lightbox) close();
    });

    lightbox.querySelector('.lightbox__prev').addEventListener('click', prev);
    lightbox.querySelector('.lightbox__next').addEventListener('click', next);

    // Thumb clicks
    lightbox.querySelector('.lightbox__thumbs').addEventListener('click', function (e) {
      var btn = e.target.closest('.lightbox__thumb');
      if (btn) goTo(parseInt(btn.dataset.index, 10));
    });

    // Keyboard
    document.addEventListener('keydown', function (e) {
      if (!lightbox || lightbox.hidden) return;
      if (e.key === 'Escape') {
        if (isZoomed) {
          var img = lightbox.querySelector('.lightbox__viewport .lightbox__image');
          if (img) zoomOut(img);
        } else {
          close();
        }
        return;
      }
      if (isZoomed) return; // Arrow keys only navigate when not zoomed
      if (e.key === 'ArrowLeft') { prev(); return; }
      if (e.key === 'ArrowRight') { next(); return; }
      if (e.key === 'Tab') trapFocus(e);
    });

    // Touch swipe (skip when zoomed)
    lightbox.addEventListener('touchstart', function (e) {
      touchStartX = e.changedTouches[0].screenX;
      touchStartY = e.changedTouches[0].screenY;
    }, { passive: true });

    lightbox.addEventListener('touchend', function (e) {
      if (isZoomed) return;
      var dx = e.changedTouches[0].screenX - touchStartX;
      var dy = e.changedTouches[0].screenY - touchStartY;
      if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 50) {
        if (dx < 0) next(); else prev();
      }
    }, { passive: true });
  }

  function trapFocus(e) {
    var focusable = lightbox.querySelectorAll(
      'button:not([disabled]), [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
    );
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (e.shiftKey) {
      if (document.activeElement === first) { e.preventDefault(); last.focus(); }
    } else {
      if (document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  }

  // ─── Gallery click delegation ─────────────────────────────────────────────────

  function getSlideIndex(slides, target) {
    for (var i = 0; i < slides.length; i++) {
      if (slides[i] === target || slides[i].contains(target)) return i;
    }
    return -1;
  }

  function handleGalleryClick(e) {
    var gallery = e.currentTarget;

    var imageSlides = gallery.querySelectorAll('.images .swiper-slide[data-lightbox-type]');
    var imgIdx = getSlideIndex(imageSlides, e.target);
    if (imgIdx !== -1) {
      // Pass the slide itself as the trigger so focus returns to it on close
      open(gallery, imgIdx, imageSlides[imgIdx]);
      return;
    }

    var thumbSlides = gallery.querySelectorAll('.thumbnails .swiper-slide');
    var thumbIdx = getSlideIndex(thumbSlides, e.target);
    if (thumbIdx !== -1) {
      e.preventDefault();
      // Return focus to the main gallery slide that corresponds to the thumbnail
      open(gallery, thumbIdx, imageSlides[thumbIdx] || null);
    }
  }

  function handleGalleryKeydown(e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var gallery = e.currentTarget;
    var imageSlides = gallery.querySelectorAll('.images .swiper-slide[data-lightbox-type]');
    var idx = getSlideIndex(imageSlides, e.target);
    if (idx !== -1) {
      e.preventDefault();
      open(gallery, idx, imageSlides[idx]);
    }
  }

  // ─── Init ─────────────────────────────────────────────────────────────────────

  function init() {
    var galleries = document.querySelectorAll('.product-gallery');
    for (var i = 0; i < galleries.length; i++) {
      galleries[i].addEventListener('click', handleGalleryClick);
      galleries[i].addEventListener('keydown', handleGalleryKeydown);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
